<template lang="html">
  <v-dialog
  v-model="dialog"
  width="500"
  >
  <template v-slot:activator="{ on }">
    <v-btn flat v-on="on">
      <v-icon color="blue darken-2"
      >
        edit
      </v-icon>
    </v-btn>
</template>

<v-toolbar class="pt-5 blue darken-4">
  <v-toolbar-title class="white--text"><h4>Anmelden</h4></v-toolbar-title>
</v-toolbar-items>
</v-toolbar>
<v-card>
  <v-card-text class="pt-4">
    <div>
      <v-form v-model="valid" ref="form">
        <v-text-field
        label="Passwort"
        v-model="password"
        :append-icon="e1 ? 'visibility' : 'visibility_off'"
        :append-icon-cb="() => (e1 = !e1)"
        :type="e1 ? 'password' : 'text'"
        required
        ></v-text-field>
        <v-checkbox v-model="isAdmin" label="admin"></v-checkbox>
        <div v-if="this.password != '' && password.length < 6 && showErrors" style="color:red">
          {{ lang.a_jelszonak_minimum_hat_karakternek_kell_lennie }}
        </div>
        <div>{{response}}</div>
        <v-layout justify-space-between>
          <v-btn @click="submit" >Go</v-btn>
        </v-layout>
      </v-form>
    </div>
  </v-card-text>
</v-card>
</v-dialog>
</template>

<script>
import axios from 'axios';
   export default {
      props: {
        userId: String
      },
     data(){
       return {
         isAdmin: false,
         dialog: false,
         valid: false,
         showErrors: false,
         password: '',
         response: '',
         e1: 1,
       }
     },
     methods: {
      _findUser_(){
        axios.get('finduser.php', {params: {id: this.userId}})
        .then(response => {
          if (response.data.success) {
            this.isAdmin = response.data.admin == 1 ? true : false
          }else {
            this.response = "Valami hiba történt"
          }
        })
      },
       async submit () {
         this.showErrors = true
         if (this.password != '' && this.password.length < 6) return
         axios.post('updateuser.php', {id: this.userId, password: this.password, admin: this.isAdmin ? 1 : 0})
         .then(response => {
           this.showErrors = false
           if (response.data.success) {
             this.response = this.lang.muvelet_sikeresen_vegrehajtva
             this.password = ''
             this.email = ''
             this.isAdmin = false
             setTimeout(function(){
               this.dialog = false
               this.$emit('itemUpdated')
             }.bind(this), 500);
           } else {
             this.response = this.lang.hiba_tortent_a_muvelet_vegrehajtasa_soran
           }
         })
         .catch(e => {
           this.response = this.lang.hiba_tortent_a_muvelet_vegrehajtasa_soran
         })
       }
     },
     watch: {
       dialog(val){
           if (!val) {
             this.password = ''
             this.response = ''
             this.showErrors = false
           } else {
             this._findUser_()
           }
       }
     }
   }
 </script>
